import axiosInstance, { API_BASE_URL } from './apiConfig';

const STORAGE_PREFIX = '/storage/';
const STORAGE_PREFIX_WITHOUT_SLASH = 'storage/';
const FILE_VIEW_PATH = '/fileStorage/view';

export const getRelativeStoragePath = (filePath?: string) => {
  if (!filePath) return '';

  let path = String(filePath).trim().replace(/\\/g, '/');

  try {
    const parsedUrl = new URL(path, window.location.origin);

    if (parsedUrl.pathname.endsWith(FILE_VIEW_PATH)) {
      return parsedUrl.searchParams.get('path') || '';
    }

    path = parsedUrl.pathname;
  } catch {
    // Keep the original path for non-URL values.
  }

  const storageIndex = path.indexOf(STORAGE_PREFIX);
  if (storageIndex >= 0) {
    path = path.slice(storageIndex + STORAGE_PREFIX.length);
  } else if (path.startsWith(STORAGE_PREFIX_WITHOUT_SLASH)) {
    path = path.slice(STORAGE_PREFIX_WITHOUT_SLASH.length);
  } else {
    path = path.replace(/^\/+/, '');
  }

  try {
    return decodeURIComponent(path);
  } catch {
    return path;
  }
};

export const getFileViewUrl = (filePath?: string) => {
  const relativePath = getRelativeStoragePath(filePath);

  return relativePath
    ? `${API_BASE_URL}${FILE_VIEW_PATH}?path=${encodeURIComponent(relativePath)}`
    : '';
};

type UploadFileOptions = {
  file: File;

  category: string;

  customFileName?: string;

  organizationName?: string;

  trustRegNumber?: string;

  surveyNumber?: string;

  propertyName?: string;

  subPropertyName?: string;
};

export const uploadFile = async ({
  file,
  category,
  customFileName,

  organizationName,
  trustRegNumber,
  surveyNumber,
  propertyName,
  subPropertyName,
}: UploadFileOptions) => {
  const data = new FormData();

  data.append('file', file);

  data.append('category', category);

  if (customFileName) {
    data.append('customFileName', customFileName);
  }

  if (organizationName) {
    data.append('organizationName', organizationName);
  }

  if (trustRegNumber) {
    data.append('trustRegNumber', trustRegNumber);
  }

  if (surveyNumber) {
    data.append('surveyNumber', surveyNumber);
  }

  if (propertyName) {
    data.append('propertyName', propertyName);
  }

  if (subPropertyName) {
    data.append('subPropertyName', subPropertyName);
  }

  try {
    const response = await axiosInstance.post('/fileStorage/upload', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Upload failed');
  }
};

export const removeFile = async (links?: string[]) => {
  try {
    const response = await axiosInstance.post('/fileStorage/remove', {
      links,
    });

    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Remove file failed');
  }
};
